module.exports = __webpack_public_path__ + "static/img/50.0936563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/50.png
// module id = oakK
// module chunks = 1